import { render, staticRenderFns } from "./PaginaAdminExpedientes.vue?vue&type=template&id=77d896be"
import script from "./PaginaAdminExpedientes.vue?vue&type=script&lang=js"
export * from "./PaginaAdminExpedientes.vue?vue&type=script&lang=js"
import style0 from "./PaginaAdminExpedientes.vue?vue&type=style&index=0&id=77d896be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports